import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFreezeApplication, CreateFreezeApplicationData } from "@/http/freezeApplicationsApi";
import { getFreezeApplicationsQueryKey } from "@/utils/queryKeys";

interface CreateFreezeApplicationParams {
  phone: string;
  data: CreateFreezeApplicationData;
  clubId?: string;
}

export const useCreateFreezeApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ phone, data, clubId }: CreateFreezeApplicationParams) => {
      const response = await createFreezeApplication(phone, data, clubId);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getFreezeApplicationsQueryKey(),
      });
    },
  });
};
